import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {FormGroup} from '@angular/forms'

@Component({
  selector: 'dmmp-form-select-inside-validations',
  templateUrl: './select-inside-validations.component.html',
})
export class SelectInsideValidationsComponent implements OnInit {
  @Input() field
  @Input() identifier
  @Input() group: FormGroup
  @Input() fieldData
  @Input() formSelects
  @Input() formSelectFilter
  @Output() changeSelect: EventEmitter<any> = new EventEmitter<any>()

  constructor() {
  }

  ngOnInit() {
  }
}
